/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import moment from 'moment';
import { Icon, Input, Modal } from '../..';
import { Layaway, fetchSearchItems } from '../../../context/storeContext';
import { Sale } from '../../../pages/POSTeller/POSTeller';
import roundUp from '../../../utils/roundUp';
import useFetchAsync from '../../../hooks/useFetchAsync';

type ModalProps = {
  onCloseModal: () => void;
  onRetrieveSale: (sale: Sale) => void;
  onDeleteSale: (deleteId: number) => void;
  storeId: number;
};

function RetrieveLayaways({
  onCloseModal,
  onRetrieveSale,
  onDeleteSale,
  storeId,
}: ModalProps) {
  const [deleteIds, setDeleteIds] = React.useState<number[]>([]);
  const { data, status, error, run } = useFetchAsync();
  const [search, setSearch] = React.useState('');

  const fetchItemsCall = React.useCallback(fetchSearchItems, []);

  const layaways = React.useMemo(() => {
    if (!data) return [];

    const { layaways: fndLayaways } = data as { layaways: Layaway[] };

    if (!search) return fndLayaways;

    return fndLayaways.filter(fndLayaway =>
      fndLayaway.customer.toLowerCase().includes(search.toLowerCase()),
    );
  }, [data, search]);

  React.useEffect(() => {
    fetchItemsCall(`/layaways?store=${storeId}`, {}, run);
  }, [fetchItemsCall, run, storeId]);

  const handleOnRetrieveLayaway = (layaway: Layaway) => {
    onRetrieveSale({
      ...layaway.sale,
      layawayId: layaway.id,
      customer: {
        id: layaway.customerId,
        name: layaway.customer,
      },
      cashier: {
        id: layaway.userId,
        name: layaway.user,
      },
      createdAt: '',
    });
    onCloseModal();
  };

  const handleOnDeleteSale = (layaway: Layaway) => {
    setDeleteIds(fndDeleteIds => [...fndDeleteIds, layaway.id]);
    onDeleteSale(layaway.id);
  };

  return (
    <Modal onClose={onCloseModal} show onHide={() => false}>
      <div className="rounded-md bg-white min-w-[800px]">
        <div className="flex flex-col p-5">
          <div className="flex flex-row justify-between items-center gap-4 mb-2">
            <h3 className="text-pos-black text-[20px] font-semibold inline-flex whitespace-pre">
              Layaways
            </h3>

            <div className="relative flex flex-row items-center">
              <Icon
                id="iconSearch"
                className="absolute w-[15px] h-[15px] my-auto top-0 bottom-0 left-4 fill-gray-300 stroke-gray-300"
              />
              <Input
                name="q"
                placeholder="Search by customer"
                value={search}
                className="!pl-[38px] w-[400px]"
                onChange={event => setSearch(event.target.value)}
              />
            </div>
          </div>
          <div className="mt-2 mb-2 overflow-x-auto overflow-y-auto relative max-h-[500px] min-h-[200px]">
            <table className="table-auto border-collapse w-full whitespace-no-wrap bg-white table-striped relative">
              <thead>
                <tr className="text-left bg-pos-header-bg sticky top-0 z-10">
                  <th className="!text-xbase font-semibold">#</th>
                  <th className="!text-xbase font-semibold">Date</th>
                  <th className="!text-xbase font-semibold">Cashier</th>
                  <th className="!text-xbase font-semibold">Customer</th>
                  <th className="!text-xbase font-semibold">Total</th>
                  <th className="!text-xbase font-semibold">Status</th>
                  <th className="!text-xbase font-semibold">Action</th>
                </tr>
              </thead>
              <tbody className="relative">
                {status === 'IDLE' || status === 'LOADING' ? (
                  <tr className="flex absolute inset-0 bg-[#f2f2f2] bg-opacity-75 transition-opacity">
                    <td
                      colSpan={8}
                      rowSpan={7}
                      className="!border-none w-full h-full"
                    >
                      <div className="fixed left-[50%] translate-x-[-50%] top-[50%] flex flex-col items-center justify-center p-4 font-normal">
                        <Icon id="loader" className="w-[50px] h-[50px]" />
                        <span className="text-pos-black">
                          Loading layaways...
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : layaways.length === 0 ? (
                  <tr className="flex absolute inset-0 bg-[#f2f2f2] bg-opacity-75 transition-opacity">
                    <td
                      colSpan={8}
                      rowSpan={7}
                      className="!border-none w-full h-full"
                    >
                      <div className="fixed left-[50%] translate-x-[-50%] top-[50%] flex flex-col items-center justify-center p-4 font-normal">
                        <span className="text-pos-black test-sm">
                          No sales on credit!
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  layaways
                    .filter(fndLayaway => !deleteIds.includes(fndLayaway.id))
                    .map((fndLayaway, index) => (
                      <tr key={fndLayaway.id}>
                        <td className="!text-sm">{index + 1}</td>
                        <td className="!text-sm">
                          {moment(fndLayaway.createdAt).format('DD-MM-YYYY')}
                        </td>
                        <td className="!text-sm">{fndLayaway.user || '-'}</td>
                        <td className="!text-sm">
                          {fndLayaway.customer || '-'}
                        </td>
                        <td className="!text-sm !font-semibold">
                          {roundUp(fndLayaway.sale.total, 2).toFixed(2)}
                        </td>
                        <td className="!text-sm">
                          {fndLayaway.status === 'Complete' ? (
                            <span className="bg-green-200 text-pos-green  py-1 px-3 rounded-full !text-[13px]">
                              Complete
                            </span>
                          ) : (
                            <span className="bg-red-200 text-pos-red  py-1 px-3 rounded-full">
                              {fndLayaway.status}
                            </span>
                          )}
                        </td>
                        <td>
                          <div className="flex flex-row items-center space-x-4">
                            <button
                              title="Retrieve"
                              type="button"
                              onClick={() =>
                                handleOnRetrieveLayaway(fndLayaway)
                              }
                              disabled={fndLayaway.status === 'Complete'}
                              className="bg-pos-green border border-[rgba(27,31,36,0.15)] inline-flex py-2 
                            px-3 text-white text-[13px] leading-none rounded-md cursor-pointer 
                            disabled:cursor-not-allowed disabled:text-gray-300 disabled:opacity-[0.8]"
                            >
                              Continue With Sale
                            </button>
                            <button
                              onClick={() => handleOnDeleteSale(fndLayaway)}
                              title="Delete"
                              type="button"
                              className="w-[16px] h-[16px] transform hover:scale-110"
                            >
                              <Icon
                                id="iconTableDelete"
                                className="w-[16px] h-[16px] fill-pos-gray"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default RetrieveLayaways;
